export const en = {
  appTitle: 'HACK THE PLANET',
  appSubtitle: 'DEFEND THE SYSTEM',
  tagline: 'Understand attack techniques. Protect systems.',
  nav: {
    home: 'Home',
    explore: 'Atlas / Attack Map',
    status: 'Status',
    chains: 'Attack Chains',
    tools: 'Tools DB',
    search: 'Search',
    categories: 'Categories',
  },
  actions: {
    openAtlas: 'Open Atlas',
    searchPlaceholder: 'Search techniques…',
    attack: 'ATTACK',
    defense: 'DEFENSE',
    filters: 'Filters',
    clearFilters: 'Clear filters',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    reset: 'Reset',
    fitWidth: 'Fit width',
    fitScreen: 'Fit image',
    fit100: '100 %',
    fullscreen: 'Fullscreen',
    expandExplainatory: 'Expand explainatory',
    collapseExplainatory: 'Collapse explainatory',
    language: 'Language',
    back: 'Back',
    menu: 'Menu',
  },
  technique: {
    related: 'Related techniques',
    detection: 'Detection',
    defense: 'Defenses',
    sources: 'Sources',
    facts: 'Facts overview',
    short: 'In brief',
    variants: 'Variants',
    flow: 'Typical flow',
    toc: 'Contents',
    tools: 'Tools',
    toolsKali: 'Kali',
    toolsCommon: 'Common',
    toolsDefensive: 'Defense',
    toolsEmpty: 'No tools listed for this entry.',
    toolsLabNote: 'Usage examples apply only to authorized labs and your own test environments.',
    notFound: 'Not found',
    notFoundBody: 'Technique "{slug}" does not exist.',
    backToAtlas: 'Back to Atlas',
    subcategory: 'Subcategory',
    attackSurface: 'Attack surface',
    difficulty: 'Difficulty',
    risk: 'Risk',
    status: 'Status',
    readerMode: 'Reader mode',
    reviewMode: 'Review mode',
    noImage: 'No Image available',
    imageLoadError: 'Image could not be loaded',
  },
  status: {
    title: 'Content status',
    needsReview: 'Needs Review',
    draft: 'Draft',
    generated: 'Generated',
    complete: 'Complete',
    review: 'Review',
    progress: 'Content progress',
    elaborated: 'elaborated',
    final: 'final',
    total: 'Total',
    elaboratedLabel: 'Elaborated',
    finalLabel: 'Final',
    missingImage: 'Missing image',
    missingDefense: 'Missing defense',
    missingDetection: 'Missing detection',
    missingSources: 'Missing sources',
    missingMetadata: 'Missing metadata',
    uncategorized: 'Uncategorized',
    brokenRelated: 'Broken related',
    categories: 'Categories',
    entries: 'entries',
    emptyHidden: '(empty — hidden from nav)',
    imagesDe: 'German images',
    imagesEn: 'English images',
    missingEnImages: 'Missing English images',
    missingMethods: 'Missing methods',
    coverageTitle: 'Image coverage DE / EN',
    missingEnTitle: 'Techniques with DE image but no EN image',
    missingMethodsTitle: 'Missing methods / gaps',
    missingEnContent: 'Missing English content',
  },
  chains: {
    title: 'Attack Chains',
    intro: 'Multi-step attack paths from the atlas — from initial access through lateral movement to exfiltration. Each chain links existing techniques into a clear sequence, grouped by goal.',
    empty: 'No attack chains are available yet.',
    steps: 'Steps',
    groupedBy: 'Grouped by attack goal',
    oneChain: 'chain',
    nChains: 'chains',
    allChains: 'View all attack chains',
    moreInGroup: 'more in this group',
    unknownGoal: 'Other chains',
    goals: {
      'initial-access': 'Initial access / credential theft',
      'lateral-movement': 'Lateral movement / privilege escalation',
      'web-compromise': 'Web app compromise',
      'cloud-container': 'Cloud / containers',
      'wireless-network': 'Wireless / network',
      'physical-social': 'Physical / social engineering',
      'ai-llm': 'AI / LLM',
      'data-exfil': 'Data exfiltration',
      other: 'Other chains',
    },
  },
  tools: {
    title: 'Tools DB',
    intro: 'Tool database for the atlas: type follows Kali-style menus (Wifi, Cracker, Web, …). Origin (Kali / common / Defense) and tags are separate filters. For authorized exercises only.',
    searchPlaceholder: 'Search tools…',
    filterCategory: 'Category',
    filterKind: 'Type',
    filterSource: 'Origin',
    filterTag: 'Tag',
    allCategories: 'All categories',
    allKinds: 'All types',
    allSources: 'All origins',
    allTags: 'All tags',
    results: 'Results',
    empty: 'No tools match these filters.',
    notFound: 'Tool not found.',
    backToHub: 'Back to Tools DB',
    officialDocs: 'Official documentation',
    useCases: 'Use cases',
    readme: 'Overview & usage',
    aliases: 'Aliases',
    relatedTechniques: 'Related techniques',
    noRelated: 'No linked techniques.',
    statTools: 'Tools',
    arts: {
      'information-gathering': 'Information gathering',
      'vulnerability-analysis': 'Vulnerability analysis',
      'web-application': 'Web',
      'database-assessment': 'Databases',
      'password-attacks': 'Password / cracker',
      wireless: 'Wireless',
      'reverse-engineering': 'Reverse engineering',
      exploitation: 'Exploitation',
      'sniffing-spoofing': 'Sniffing / spoofing',
      'post-exploitation': 'Post-exploitation',
      forensics: 'Forensics',
      reporting: 'Reporting',
      'social-engineering': 'Social engineering',
      hardware: 'Hardware / RFID',
      defensive: 'Defense',
      utilities: 'Utilities',
    },
    chips: {
      'information-gathering': 'Recon',
      'vulnerability-analysis': 'Vuln',
      'web-application': 'Web',
      'database-assessment': 'Database',
      'password-attacks': 'Cracker',
      wireless: 'Wifi',
      'reverse-engineering': 'RE',
      exploitation: 'Exploitation',
      'sniffing-spoofing': 'Sniffing',
      'post-exploitation': 'Post-Ex',
      forensics: 'Forensics',
      reporting: 'Reporting',
      'social-engineering': 'SE',
      hardware: 'Hardware',
      defensive: 'Defense',
      utilities: 'Utilities',
    },
  },
  promo: {
    hackerCity: {
      kicker: 'Co-op',
      title: 'Hacker City — cooperative hacking simulator',
      slogan: 'Red. Blue. No spectator mode.',
      cta: 'To the City',
    },
  },
  empty: 'No entries found.',
  indexView: 'Index',
  mapView: 'Attack Map',
  difficulties: {
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    expert: 'Expert',
  },
  severities: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
  },
} as const

export type EnStrings = typeof en
